import { useAtomValue } from 'jotai';
import { uiContextAtomTileActions } from '@rocco/ui/tile-shared/hooks/use-shared-tiles';
import type { TileViewModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { StaticTileViewModel } from '@rocco/ui/tile-static/view-models/static';

import { cn } from '@rocco/utils/cn';

export const StaticTile = (props: TileViewModel<StaticTileViewModel>) => {
    const { aspectRatio, model } = props;
    const isImage = model.type === 'photo';

    const actionsContext = useAtomValue(uiContextAtomTileActions);
    const { onStaticTileClick } = actionsContext?.trackingConfig ?? {};

    return (
        <div
            className="group flex h-full max-w-[25.3125rem] flex-col gap-[1.125rem] md:gap-[1.2rem]"
            onClick={() => onStaticTileClick?.(model.title)}
        >
            <div className="group relative h-full overflow-hidden rounded-2.5">
                <div className="flex flex-col gap-4">
                    <div
                        className={cn(
                            mapAspectRatio(aspectRatio),
                            'flex items-center justify-center overflow-hidden rounded-tile bg-gray-300'
                        )}
                    >
                        <div
                            className={cn(
                                isImage &&
                                    'flex h-[70%] w-[70%] items-center justify-center'
                            )}
                        >
                            <img
                                src={model.thumbnail.src}
                                alt={model.thumbnail.alt}
                                className={cn(
                                    isImage &&
                                        'max-h-full max-w-full bg-white object-contain p-3 shadow-md'
                                )}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col">
                            <span className="line-clamp-1 overflow-hidden text-ellipsis text-sm font-medium tracking-[0.03rem] md:text-base md:tracking-[0.02rem]">
                                {model.title}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapAspectRatio = (
    aspectRatio: TileViewModel<StaticTileViewModel>['aspectRatio']
): string => {
    const configs: Record<string, string> = {
        featured: 'h-full', // there's no aspect ratio for featured tile - it should take all available space in the grid
        default: 'aspect-tile-default',
        article: 'aspect-tile-article',
        category: 'aspect-tile-category',
        square: 'aspect-square',
    };

    return configs[aspectRatio ?? 'default'] ?? 'aspect-tile-default';
};
